<template>
  <div class="app app-ti_green">


        <router-view />
        <Foot />

    <!--  提前预加载iframe  -->
<!--    <iframe-->
<!--      style="position:absolute; width:1px; height:1px; opacity:0; pointer-events:none;top: -100px;"-->
<!--      ref="preloadIframe"-->
<!--      :src="pc1_iframeUrl"-->
<!--      frameborder="0"-->
<!--    ></iframe>-->

  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
export default {
  name: 'Main',
  data() {
    return {
      baseURL: '',
      pc1_iframeUrl: '',
      pc2_iframeUrl: ''
    };
  },
  components: {
    Header,
    Foot,
  },
  created() {
    let that = this;

    that.baseURL = localStorage.getItem('baseURL') || '';
  },
  updated() {
    let that = this;
  },
  mounted() {
    let that = this;
    this.initGameIframe()
  },
  methods: {
    outLogin() {
      this.$parent.outLogin();
    },
    openDaoTime() {
      this.openDaoTime();
    },
    closeDaoTime() {
      this.$parent.closeDaoTime();
    },
    openGamePage(name, type, code) {
      this.$parent.openGamePage(name, type, code);
    },

    goNav(url) {
      this.$parent.goNav(url);
    },
    initGameIframe() {
      if(this.$store.state.userInfo.youxi_token) {
        this.pc1_iframeUrl = `https://yuenan6.igusa.co/index/game/jump/video/jld28/room/one.php?room=one&tokens=${this.$store.state.token}&username=${this.$store.state.userInfo.username}&token=${this.$store.state.userInfo.youxi_token}&password=e10adc3949ba59abbe56e057f20f883e&ran=${Math.random()}&type=sdfatc`
        // this.pc2_iframeUrl = `https://yuenan6.igusa.co/index/game/jump/video/jld28/room/one.php?room=two&tokens=${this.$store.state.token}&username=${this.$store.state.userInfo.username}&token=${this.$store.state.userInfo.youxi_token}&password=e10adc3949ba59abbe56e057f20f883e&ran=${Math.random()}&type=sdfatc`
      }
    },
    getUserInfo() {
      this.$parent.getUserInfo();
    },
    getUserInfoShowLoding() {
      this.$parent.getUserInfoShowLoding();
    },
    doCopy(msg) {
      this.$parent.doCopy(msg);
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      // this.$parent.openKefu();
      window.ssq.push('chatOpen')
    },
    getAgentLoginUrl() {
      this.$parent.getAgentLoginUrl();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getBalance() {
      this.$parent.getBalance();
    },
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
  // watch: {
  //   //监听路由地址的改变
  //   $route: {
  //     immediate: true,
  //     handler() {
  //       let that = this;
  //       that.path = this.$route.path;
  //     },
  //   },
  // },
};
</script>

<style lang="scss" scoped>
// @import '../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/Main.vue